import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ClassificationService } from '../../shared/services/classification.service';
import { Config } from '../../shared/config';
import { IClassification, ICOAClassification } from '../../shared/models/classification';
import { Router } from '@angular/router';
import { GridComponent } from '@progress/kendo-angular-grid';
import { GroupDescriptor } from '@progress/kendo-data-query';
import { FrameworkService } from 'gadoe-framework';
import { CommonService } from 'src/app/shared/services/common.service';
import { IToolBarClick, IObjectStatus, IWFObjectType, IApplicationRoles, ISearch } from 'src/app/shared/models/common';

@Component({
  selector: 'app-classification',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './classification.component.html',
  styleUrls: ['./classification.component.css'],
  providers: [ClassificationService]
})
export class ClassificationComponent implements OnInit {
  model: ICOAClassification;
  view: boolean;
  loading = true;
  Showintroduction: boolean;
  InputClassification: ISearch;
  lineitems1: ICOAClassification[];
  lineitems: ICOAClassification[];
  editlineitems: ICOAClassification[];
  public editGridDataItem: ICOAClassification;
  public isNew: boolean;
  public opened = false;
  toolbarclick: IToolBarClick;
  checkPublish: boolean;
  public popupmessage = '';
  public isTerminate = false;
  public searchBtnText: 'Search' | 'Close Search' = 'Search';
  public groups: GroupDescriptor[] = [{ field: 'sectionHeaderName' }];
  public expandBtnText: 'Expand All' | 'Collapse All' = 'Expand All';
  sectionHeaderName: string;
  expandflag: boolean;
  showPopup: boolean;
  editwidth: number;
  buttonClick: string;
  show: boolean;
  introduction: string;
  isViewEDEy: boolean;
  isViewbtn: boolean;
  statusID: number;
  controlID: number;
  roleID: number;
  status: number;
  isAdmin: boolean;
  itroleID: number;
  toolBarTypeID: number;
  @ViewChild('gridL') grid: GridComponent;
  public cells: any = {
    textAlign: 'right'
  };
  Objectstatus: IObjectStatus[];
  constructor(private frmbuilder: FormBuilder, private frameworkService: FrameworkService,
    private dataService: ClassificationService, private commonService: CommonService,
    private route: Router) {
  }

  ngOnInit() {
    this.view = false;
    this.modelInit();
    this.refreshtoolbar();
  }
  modelInit() {
    this.model = {
      sectionLineItemColumnID: -1,
      groupHeaderID: -1,
      groupHeaderName: '',
      sectionHeaderID: -1,
      lineItemID: -1,
      name: '',
      code: '',
      description: '',
      isActive: false,
      isPublished: false,
      isPublishedStatus: '',
      sectionHeaderName: '',
      sName: '',
      groupHeaderIntroduction: '',
      createdBy: 0,
      startYear: 0,
      activeStatus: ''
    };
    Config.selectedTab = 2;
    this.toolBarTypeID = 4;
    this.checkPublish = false;
    this.showPopup = false;
    this.buttonClick = '';
    this.expandflag = false;
    this.Showintroduction = false;
    this.show = false;
    this.introduction = '';
    this.isViewEDEy = true;
    this.status = 0;
    this.itroleID = IApplicationRoles.Administrator;
    this.roleID = Config.userProfile.itApplicationRoleID;
    this.controlID = Config.selectedTabMenuItem.controlID;
    this.toolBarTypeID = 4;
    if (this.roleID !== this.itroleID || this.roleID === undefined) {
      this.isAdmin = false;
      this.editwidth = 80;
    } else {
      this.isAdmin = true;
      this.editwidth = 250;
    }

  }
  refreshtoolbar() {
    this.frameworkService.refreshToolBarItems(
      {
        controlID: Config.selectedTabMenuItem.controlID
        , roleID: Config.selectedTabMenuItem.itApplicationRoleID
        , statusID: Config.StatusID
      });
  }
  searchValues(event: ISearch) {
    this.InputClassification = event;
    if (this.InputClassification.groupclassificationID === -1) { this.view = false; } else { this.view = true; }
    this.InputClassification.fiscalYear = Config.fiscalYear;
    this.buttonClick = '';
    this.InputClassification.fiscalYearConfigID = Config.fiscalYearConfigID;
    this.InputClassification.groupclassificationName = event.groupclassificationName;
    this.getstatus();
    this.getSection();
  }
  onClickFilter(event) {
    event.filterable = !event.filterable;
  }

  getstatus() {
    this.commonService.GetObjectStatus(Config.fiscalYearConfigID, IWFObjectType.COA)
      .subscribe((response: IObjectStatus[]) => {
        this.Objectstatus = response;
        if (response.length !== 0) {
          this.status = Config.StatusID = this.Objectstatus[0].statusID;
        }
        this.frameworkService.hideSpinner();
        this.refreshtoolbar();
      },
        (err: any) => {
          this.frameworkService.logError(err),
            this.loading = false;
          this.frameworkService.hideSpinner();
        },
        () => this.frameworkService.logInfo('getstatus() retrieved systems'));
  }
  getSection() {
    this.loading = true;
    // tslint:disable-next-line:max-line-length
    this.dataService.getGridDetails(this.InputClassification.groupclassificationID, 0, this.InputClassification.fiscalYearConfigID, Config.checkPublish)
      .subscribe((response: ICOAClassification[]) => {
        this.lineitems1 = response;
        this.lineitems = response.map(o => {
          return {

            sectionLineItemColumnID: o.sectionLineItemColumnID,
            groupHeaderID: o.groupHeaderID,
            groupHeaderName: o.groupHeaderName,
            sectionHeaderID: o.sectionHeaderID,
            lineItemID: o.lineItemID,
            createdBy: o.createdBy,
            name: o.name,
            code: o.code,
            description: o.description,
            isActive: o.isActive,
            sectionHeaderName: (o.sectionHeaderName === undefined || o.sectionHeaderName === null) ? 'tttt' : o.sectionHeaderName,
            sName: o.sName,
            isPublished: o.isPublished,
            isPublishedStatus: o.isPublishedStatus,
            groupHeaderIntroduction: o.groupHeaderIntroduction,
            startYear: o.startYear,
            activeStatus: o.activeStatus
          };
        });
        this.loading = false;
        if (response.length !== 0) {
          if (this.lineitems[0].sectionLineItemColumnID !== null) {
            this.Showintroduction = false;
            this.show = true;
            this.introduction = this.lineitems[0].groupHeaderIntroduction;

            if (this.buttonClick === '') {
              this.onClickExpand('Collapse All');
            }
          }
        } else {
          this.introduction = '';
          this.show = false;
        }
      },
        (err: any) => {
          this.frameworkService.logError(err),
            this.loading = false;
        },
        () => this.frameworkService.logInfo('getLineItems() retrieved getLineItems'));

  }

  public addHandler(event) {
    // this.editGridDataItem = new ICOAClassification();
    this.editGridDataItem = {
      sectionLineItemColumnID: -1,
      groupHeaderID: this.InputClassification.groupclassificationID,
      groupHeaderName: '',
      sectionHeaderID: -1,
      lineItemID: -1,
      name: '',
      code: '',
      description: '',
      isActive: false,
      isPublished: false,
      isPublishedStatus: '',
      sectionHeaderName: '',
      sName: '',
      groupHeaderIntroduction: '',
      createdBy: 0,
      startYear: 0,
      activeStatus: ''
    };
    this.editlineitems = this.lineitems;
    this.isNew = true;
    this.buttonClick = 'Edit';
    this.showPopup = false;
  }
  public close(status) {
    this.loading = true;
    this.model.createdBy = Config.userProfile.personID;
    if (this.isTerminate && status === 'yes') {
      this.dataService.terminate(this.InputClassification.fiscalYear, this.model)
        .subscribe((response) => {
          if (response.results !== 0) {
            this.lineitems = response;
            this.getSection();
          }
        },
          (err: any) => {
            this.frameworkService.logError(err),
              this.loading = false;
          },
          () => this.frameworkService.logInfo('Dialog result: terminate'));
    } else if (!this.isTerminate && status === 'yes') {
      this.dataService.delete(this.model)
        .subscribe((response) => {
          if (response.results !== 0) {
            this.lineitems = response;
            this.getSection();
          }
        },
          (err: any) => {
            this.frameworkService.logError(err),
              this.loading = false;
          },
          () => this.frameworkService.logInfo('Dialog result: delete'));
    }
  }



  public editHandler(event) {
    this.editGridDataItem = event.dataItem;
    this.editlineitems = this.lineitems;
    this.isNew = false;
    this.buttonClick = 'Edit';
    this.showPopup = false;
  }

  public onButtonClick(event) {
    this.showPopup = true;
    if (event.startYear === this.InputClassification.fiscalYear) {
      this.buttonClick = 'DontDelete';
      this.popupmessage = '<strong>' + event.code + '-' + event.name +
        '</strong> &nbsp; is created in FY ' + this.InputClassification.fiscalYear +
        ' . It cannot be ended in the same FY ' + this.InputClassification.fiscalYear + '.';
    } else {
      this.buttonClick = 'EndYear';
      if (this.InputClassification.groupclassificationID !== 9) {
        this.dataService.checkRelation(event)
          .subscribe((response: any) => {
            if (response.results !== 0) {
              this.popupmessage = '<strong>' + event.code + '-' + event.name + '</strong> &nbsp;'
                + ' is already in Relationship. Do you want to End it ?';
            } else {
              this.popupmessage = 'Are you sure you want to End &nbsp;' + '<strong>' + event.code + '-' + event.name + '</strong>';
            }
          },
            (err: any) => {
              this.frameworkService.logError(err),
                this.loading = false;
            },
            () => this.frameworkService.logInfo('Dialog result: checkRelation,Terminate'));
      } else {
        this.popupmessage = 'Are you sure you want to End &nbsp;' + '<strong>' + event.code + '-' + event.name + '</strong>';
      }
    }
    this.isTerminate = true;
    this.model = event;
  }

  public cancelHandler() {
    this.editGridDataItem = undefined;
  }
  onClickView(event) {
    this.showPopup = true;
    this.buttonClick = 'DontDelete';
    this.popupmessage = '';
    this.model = event;
  }
  onClick(event) {
    this.showPopup = true;
    if (event.isPublished === true) {
      this.buttonClick = 'DontDelete';
      this.popupmessage = '<strong>' + event.code + '-' + event.name + '</strong> &nbsp; is already Published . We cannot delete it.';
    } else {
      if (this.InputClassification.groupclassificationID !== 9) {
        this.dataService.checkRelation(event)
          .subscribe((response: any) => {
            if (response.results !== 0) {
              this.buttonClick = 'DontDelete';
              // tslint:disable-next-line:max-line-length
              this.popupmessage = '<strong>' + event.code + '-' + event.name + '</strong> &nbsp; is already in Relationship./n We cannot Delete.';
            } else {
              this.buttonClick = 'Delete';
              // tslint:disable-next-line:max-line-length
              this.popupmessage = 'Are you sure you want to permanently delete  &nbsp; <strong> ' + event.code + '-' + event.name + '</strong>';
            }
          },
            (err: any) => {
              this.frameworkService.logError(err),
                this.loading = false;
            },
            () => this.frameworkService.logInfo('Dialog result: checkRelation ,delete'));
      } else {
        this.buttonClick = 'Delete';
        this.popupmessage = 'Are you sure you want to permanently delete  &nbsp; <strong> ' + event.code + '-' + event.name + '</strong>';
      }
    }
    this.isTerminate = false;
    this.model = event;
  }


  public saveHandler(product: ICOAClassification) {
    this.loading = true;
    if (this.isNew) {
      product.createdBy = Config.userProfile.personID;
      this.dataService.Add(this.InputClassification.fiscalYear, product)
        .subscribe((response: ICOAClassification[]) => {
          this.lineitems = response;
          this.getSection();
          this.editGridDataItem = undefined;
          this.editlineitems = undefined;
          this.frameworkService.showSuccessMessage('Saved successfully');
        },
          (err: any) => {
            this.frameworkService.logError(err),
              this.loading = false;
          },
          () => this.frameworkService.logInfo('saveHandler: Add LineiTem'));
    } else {
      this.dataService.update(product, this.InputClassification.fiscalYearConfigID)
        .subscribe((response: ICOAClassification[]) => {
          this.lineitems = response;
          this.getSection();
          this.editGridDataItem = undefined;
          this.editlineitems = undefined;
          this.frameworkService.showSuccessMessage('Saved successfully');
        },
          (err: any) => {
            this.frameworkService.logError(err),
              this.loading = false;
          },
          () => this.frameworkService.logInfo('saveHandler: Update LineiTem'));
    }
  }

  onClickExpand(text) {
    if (this.grid !== undefined) {
      if (text === 'Expand All') {
        for (let i = 0; i < this.lineitems.length; i++) {
          this.grid.expandGroup('' + i + '');
        }
        this.expandflag = true;
        this.expandBtnText = 'Collapse All';
      } else {
        for (let i = 0; i < this.lineitems.length; i++) {
          // tslint:disable-next-line:max-line-length
          this.grid.collapseGroup('' + i + '');
        }
        this.expandflag = false;
        this.expandBtnText = 'Expand All';
      }
    }
  }
  openEditor(text) {
    if (text === true) {
      this.Showintroduction = true;
    } else { this.Showintroduction = false; }
  }
}


